<template>

</template>

<script>
  export default {
     name: 'Property_DiaoBo',
     data () {
       return {
          
        };
     },
     methods: {
    
     }
   }
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/Property/Property_DiaoBo.vue